'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { List, Record } from 'immutable';
import I18n from 'I18n';
import TranslatedContent from './TranslatedContent';
import { ContentTypes, ContentTypeToContentId } from '../constants/base';

const getLanguageNameFromKey = key => key ? I18n.text(`SharedI18nStrings.languageNames.${key}`) : '';

const DEFAULTS = {
  ab: false,
  abTestId: -1,
  absoluteUrl: '',
  categoryId: null,
  contentGroupId: -1,
  contentType: '',
  domain: '',
  id: 0,
  isPublished: false,
  language: '',
  languageName: '',
  mab: false,
  mabExperimentId: -1,
  name: '',
  parentBlog: {},
  password: '',
  publicAccessRules: List(),
  publicAccessRulesEnabled: false,
  resolvedDomain: '',
  state: '',
  subcategory: '',
  translatedContent: List(),
  translatedFromId: ''
};

const getTranslatedContent = (id, {
  id: contentId,
  language,
  name
}, translatedContent) => translatedContent.filterNot(tc => tc.id === id).set(language, TranslatedContent.fromJS({
  id: contentId,
  language,
  name
}));

const getContentGroupIdForTranslation = ({
  parentBlog,
  categoryId
}, language) => {
  if (categoryId === ContentTypeToContentId[ContentTypes.BLOG_POST] && parentBlog && Object.keys(parentBlog.translations).length > 0 && parentBlog.translations[language]) {
    return parentBlog.translations[language].id;
  }

  return -1;
};

export default class PageForModals extends Record(DEFAULTS) {
  static fromJS(_ref) {
    let {
      language,
      parentBlog
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["language", "parentBlog"]);

    return new PageForModals(Object.assign({}, rest, {
      contentGroupId: parentBlog ? parentBlog.get('id') : -1,
      language,
      languageName: getLanguageNameFromKey(language),
      parentBlog: parentBlog ? parentBlog.toJS() : {}
    }));
  }

  static fromTranslatedContent({
    id,
    language,
    masterId,
    password,
    publicAccessRules,
    publicAccessRulesEnabled,
    published,
    name,
    state
  }, content, translatedContent) {
    return new PageForModals({
      contentGroupId: getContentGroupIdForTranslation(content, language),
      id,
      isPublished: published,
      language,
      languageName: getLanguageNameFromKey(language),
      name,
      password,
      publicAccessRules,
      publicAccessRulesEnabled,
      state,
      translatedContent: getTranslatedContent(id, content, translatedContent),
      translatedFromId: masterId || ''
    });
  }

}